const s = {
  name: "Chip4",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M11,5V0h2v5H11z"/>
		<path class="st0" d="M27,13H13v14h14V13z M15,25V15h10v10H15z"/>
		<path class="st0" d="M28.4,7H11.6L7,11.6v16.8l4.6,4.6h16.8l4.6-4.6V11.6L28.4,7z M9,12.4L12.4,9h15.2l3.4,3.4v15.2L27.6,31H12.4
			L9,27.6V12.4z"/>
		<path class="st0" d="M19,0v5h2V0H19z"/>
		<path class="st0" d="M27,5V0h2v5H27z"/>
		<path class="st0" d="M11,35v5h2v-5H11z"/>
		<path class="st0" d="M19,40v-5h2v5H19z"/>
		<path class="st0" d="M27,35v5h2v-5H27z"/>
		<path class="st0" d="M5,29H0v-2h5V29z"/>
		<path class="st0" d="M0,21h5v-2H0V21z"/>
		<path class="st0" d="M5,13H0v-2h5V13z"/>
		<path class="st0" d="M35,29h5v-2h-5V29z"/>
		<path class="st0" d="M40,21h-5v-2h5V21z"/>
		<path class="st0" d="M35,13h5v-2h-5V13z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Chip4
};
